import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CookieSnackbarService } from './services/cookie-snackbar.service';
import { CookieSnackbarComponent } from './components/cookie-snackbar/cookie-snackbar.component';
import { GuardsCheckEnd, GuardsCheckStart, NavigationEnd, Router } from '@angular/router';
import { BrandService } from './services/brand.service';
import { Brand } from './models/brand.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  loading: boolean;
  brand: Brand;

  constructor(
    private titleService: Title,
    private cookieSnackbarService: CookieSnackbarService,
    private router: Router,
    private brandService: BrandService
  ) {
    this.titleService.setTitle(`BillTech Pay`);

    if (!this.cookieSnackbarService.hasCookieConfirmed()) {
      this.cookieSnackbarService.openCookieSnackBar(CookieSnackbarComponent);
    }

    this.router.events.subscribe(event => {
      if (event instanceof GuardsCheckStart) {
        this.loading = true;
      }
      if (event instanceof GuardsCheckEnd || event instanceof NavigationEnd) {
        this.loading = false;
      }
    });

    this.brand = this.brandService.brand;
  }
}
